import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "row",
  id: "visit-request"
}
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "row mx-2 my-5" }
const _hoisted_6 = { class: "col-sm-12 col-md-4 order-md-last" }
const _hoisted_7 = { class: "col-sm-12 col-md-8" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 card" }
const _hoisted_10 = { class: "text-center mt-5" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "h2" }
const _hoisted_13 = { class: "applicant-contact mb-0 w-50 m-auto" }
const _hoisted_14 = { class: "mx-5" }
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_join_links = _resolveComponent("join-links")!
  const _component_modal = _resolveComponent("modal")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && typeof(_ctx.interview) !== 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", null, "An interview has been scheduled for " + _toDisplayString(_ctx.interview.applicant.name) + " by " + _toDisplayString(_ctx.interview.trainer.name) + " on " + _toDisplayString(_ctx.moment(_ctx.interview.utc_time || _ctx.interview.local_time).format('MM/DD/YY h:mm a')) + ".", 1),
                    _createVNode(_component_join_links, {
                      joinevent: _ctx.interview,
                      label: 'Interview',
                      user: _ctx.user
                    }, null, 8, ["joinevent", "user"]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-lg btn-secondary w-100 mb-2",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showCancelModal && _ctx.showCancelModal(...args)))
                    }, "Cancel")
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("img", {
                            class: "rounded-circle",
                            width: "100",
                            src: _ctx.interview.trainer.image
                          }, null, 8, _hoisted_11),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.interview.trainer.name), 1),
                          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.interview.trainer.email), 1),
                          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "applicant-contact mb-5 w-50 m-auto" }, "Trainer", -1)),
                          _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "hr-dark" }, null, -1))
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Experience", -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.interview.trainer.experience), 1),
                          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode(_component_modal, {
            modelValue: _ctx.cancelModal,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cancelModal) = $event))
          }, {
            header: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("Cancel Interview")
            ])),
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createElementVNode("p", null, "Are you sure you want to cancel this interview?", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-xs float-end",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelInterview && _ctx.cancelInterview(...args)))
              }, "Cancel Interview")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && typeof(_ctx.interview) === 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _cache[9] || (_cache[9] = _createElementVNode("p", null, "Error Loading Interview", -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.loadErrorMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}